import { useRef } from "react";

export function useLatestRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
